import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { useApolloClient } from "@apollo/client";
import {
	NextSailingReportStatusesDocument,
	NextSailingReportStatusesQuery,
} from "__generated__/view/sailingreports/graphql/sailingReport.queries.generated";
import { SelectProps } from "@cofano/cck/Select/Select";
import { ChildPropsFromArray } from "types/commons";
import { SailingReportStatus } from "__generated__/enums";

export type SailingReportStatusSelectOption = ChildPropsFromArray<NextSailingReportStatusesQuery, "nextSailingReportStatuses">;

const SailingReportStatusSelect = ({
	currentStatus,
	...rest
}: Omit<SelectProps<SailingReportStatusSelectOption, false>, "fetchOptions" | "paginated" | "multiple"> & {
	currentStatus?: SailingReportStatus | null;
}) => {

	const client = useApolloClient();

	const onFetchOptions = async () => {
		try {
			const result = await client.query({
				query: NextSailingReportStatusesDocument,
				variables: {
					currentStatus: currentStatus,
				},
			});

			return result.data.nextSailingReportStatuses;
		} catch (response) {
			return [];
		}
	};

	return (
		<Select
			fetchOptions={onFetchOptions}
			getOptionLabel={(option) => intl.formatMessage({ id: `${option.languageKeyPrefix}${option.name}` })}
			getOptionColor={option => option.color}
			disableSearch
			{...rest}
		/>
	);
};

export default SailingReportStatusSelect;
